import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Loading } from '../../components/common/Loading';
import { ProductAction } from '../../actions/ProductAction';
import ProductCard from './ProductCard';

const ProductFavList = ({ GetFavProductAll, products, sn }) => {

	// 조회 중 표시 — ProductReducer.isLoading 은 다른 제품 조회와 공유돼 쓰지 않는다. 최신 요청만 해제한다.
	const [loading, setLoading] = useState(true);
	const reqRef = useRef(0);

	useEffect(() => () => { reqRef.current += 1; }, []);

	useEffect(() => {
		const reqId = ++reqRef.current;
		setLoading(true);
		Promise.resolve(GetFavProductAll()).catch((e) => {
			console.warn('[ProductFavList] favorite list failed', { handler: 'ProductFavList', reason: e?.message || String(e) });
		}).finally(() => {
			if (reqId === reqRef.current) setLoading(false);
		});
	}, [sn])

	if (loading) return <Loading />;

	return (
		<>
			<ul className="listview link-listview">
				{(products ?? []).map((item, index) =>
					<li key={index}>
						<ProductCard item={item} />
					</li>
				)}
			</ul>
		</>
	);
};

const mapState = (state) => {
	const products = state.FavoriteReducer.products;
	const sn = state.FavoriteReducer.sn;
	return { products, sn };
};

const mapDispatch = (dispatch) => ({
	GetFavProductAll: (filter) => dispatch(ProductAction.GetFavProductAll(filter)),
	//GetFavProductAll: (filter) => dispatch(ProductAction.GetProductAll(filter)),
});

export default connect(mapState, mapDispatch)(ProductFavList);